import PropTypes from 'prop-types'
import { memo, useMemo } from 'react'
import classNames from 'lib/util/classNames'
import styles from './Header.module.scss'

/**
 * The Tooltip `Header`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function Header (props) {
  const { children, className } = props
  const classNameOutput = useMemo(
    () => classNames([className, styles.header]),
    [className]
  )

  return <h1 className={classNameOutput}>{children}</h1>
}

/** @type {object} */
Header.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
}

/** @type {object} */
Header.defaultProps = {
  className: '',
  children: null
}

// Memoize
export default memo(Header)
